export default {
    viewDoctor: 'viewDoctor',
    viewClinic: 'viewClinic',
    requests: 'requests',
    request: 'request',
    chat: 'chat',
}
